export const footerFallbackZh = {
  id: 1,
  locale: 'zh',
  links: [
    {
      id: 10,
      title: 'RuStore 应用商店',
      elements: [
        {
          id: 66,
          title: '关于RuStore',
          href: 'http://rustore.ru/help/zh',
          isTargetBlank: true,
        },
        {
          id: 65,
          title: 'RuStore 为电视',
          href: 'https://www.rustore.ru/tv',
          isTargetBlank: true,
        },
        {
          id: 61,
          title: 'RuStore 为手机',
          href: 'https://www.rustore.ru/instruction',
          isTargetBlank: false,
        },
        {
          id: 62,
          title: '媒体工具包 (为媒体与博主)',
          href: 'https://www.rustore.ru/media-kit',
          isTargetBlank: true,
        },
        {
          id: 63,
          title: '发现漏洞吗？(Bug Bounty项目)',
          href: 'https://bugbounty.vk.company',
          isTargetBlank: true,
        },
        {
          id: 64,
          title: '用户协议',
          href: 'http://rustore.ru/help/zh',
          isTargetBlank: true,
        },
        {
          id: 67,
          title: '用户隐私',
          href: 'http://rustore.ru/help/zh',
          isTargetBlank: true,
        },
      ],
    },
    {
      id: 11,
      title: '帮助',
      elements: [
        {
          id: 68,
          title: '在电视上安装RuStore',
          href: 'https://www.rustore.ru/help/en/users/start/install-on-tv/install-apk-on-tv',
          isTargetBlank: true,
        },
        {
          id: 70,
          title: '在手机上安装RuStore',
          href: 'https://www.rustore.ru/help/en/users/start/app-install',
          isTargetBlank: true,
        },
        {
          id: 69,
          title: 'RuStore用户帮助',
          href: 'https://www.rustore.ru/help/en/users/start',
          isTargetBlank: true,
        },
        {
          id: 71,
          title: '购买与退款',
          href: 'https://www.rustore.ru/help/en/users/purchases-and-returns',
          isTargetBlank: true,
        },
        {
          id: 72,
          title: 'RuStore授权 (SBER ID, VK ID)',
          href: 'https://www.rustore.ru/help/en/users/authorization',
          isTargetBlank: true,
        },
        {
          id: 76,
          title: '应用程序更新失败',
          href: 'https://www.rustore.ru/help/en/users/app-management/update-failure',
          isTargetBlank: true,
        },
        {
          id: 73,
          title: '家长控制',
          href: 'https://www.rustore.ru/help/en/users/start/parental-control',
          isTargetBlank: true,
        },
        {
          id: 74,
          title: '如何为应用程序撰写评论',
          href: 'https://www.rustore.ru/help/en/users/app-management/app-review',
          isTargetBlank: true,
        },
      ],
    },
    {
      id: 12,
      title: '为开发者',
      elements: [
        {
          id: 77,
          title: '通过RuStore赚钱',
          href: 'https://www.rustore.ru/help/en/developers/monetization',
          isTargetBlank: true,
        },
        {
          id: 75,
          title: '成为开发者',
          href: 'https://www.rustore.ru/help/en/developers',
          isTargetBlank: true,
        },
        {
          id: 78,
          title: '访问RuStore控制台',
          href: 'https://dev.rustore.ru/zh',
          isTargetBlank: true,
        },
        {
          id: 79,
          title: 'RuStore SDK（技术手册)',
          href: 'https://www.rustore.ru/help/en/sdk',
          isTargetBlank: true,
        },
        {
          id: 80,
          title: '国外公司注册',
          href: 'https://www.rustore.ru/help/en/developers/developer-account/registration-developer/foreign-company-developer-account',
          isTargetBlank: true,
        },
        {
          id: 81,
          title: '分销协议',
          href: 'https://www.rustore.ru/help/en/legal/developers-agreement',
          isTargetBlank: true,
        },
        {
          id: 82,
          title: '开发者隐私',
          href: 'https://www.rustore.ru/help/en/legal/privacy-policy-developers',
          isTargetBlank: true,
        },
      ],
    },
    {
      id: 13,
      title: '热门类别',
      elements: [
        {
          id: 83,
          title: '有用的',
          href: 'https://www.rustore.ru/prostore',
          isTargetBlank: true,
        },
        {
          id: 84,
          title: 'Android游戏',
          href: 'https://www.rustore.ru/catalog/games',
          isTargetBlank: true,
        },
        {
          id: 85,
          title: '银行应用程序',
          href: 'https://www.rustore.ru/catalog/finance',
          isTargetBlank: true,
        },
        {
          id: 87,
          title: '国家应用程序',
          href: 'https://www.rustore.ru/catalog/state',
          isTargetBlank: true,
        },
        {
          id: 86,
          title: '购物应用程序',
          href: 'https://www.rustore.ru/catalog/purchases',
          isTargetBlank: true,
        },
        {
          id: 94,
          title: '为家长',
          href: 'https://www.rustore.ru/catalog/parenting',
          isTargetBlank: true,
        },
      ],
    },
    {
      id: 14,
      title: '有用的',
      elements: [
        {
          id: 92,
          title: 'Android优化：如何加速您的设备',
          href: 'https://www.rustore.ru/prostore/populyarnye-igry-vybor-redakcii',
          isTargetBlank: true,
        },
        {
          id: 88,
          title: 'Android 游戏：玩家最受欢迎的应用',
          href: 'https://www.rustore.ru/prostore/10-prilozhenij-dlya-detskogo-telefona-interesno-i-bezopasno',
          isTargetBlank: true,
        },
        {
          id: 93,
          title: 'Android 摄影：如何拍摄完美照片',
          href: 'https://www.rustore.ru/prostore/kak-skachat-prilozhenie-sberkids-na-android',
          isTargetBlank: true,
        },
        {
          id: 89,
          title: 'Android TV 指南：如何设置和使用',
          href: 'https://www.rustore.ru/prostore/kak-polzovatsya-telefonom-vmesto-karty-beskontaktnye-platezhi-android',
          isTargetBlank: true,
        },
      ],
    },
  ],
  leftSideContent: {
    id: 3,
    copyright: '© VK 2022—2025 RuStore',
    qrCodeDescription: '扫二维码下载RuStore, <br/> 按照指南操作',
    rustoreLogoHref: {
      id: 1532,
      name: 'logo_color_30 px.svg',
      width: 128,
      height: 32,
      url: 'https://static.rustore.ru/rustore-strapi/6/logo_color_30_px_57aa562dd4.svg',
    },
    qrCodeHref: {
      id: 712,
      name: 'qr-code.svg',
      width: 136,
      height: 136,
      url: 'https://static.rustore.ru/rustore-strapi/6/qr_code_340f0a7aed.svg',
    },
    webLandingSocialLinks: [
      {
        id: 12,
        href: 'https://vk.com/rustore_official',
        isTargetBlank: true,
        logoHref: {
          id: 1535,
          name: 'Iko_VK_28.svg',
          width: 28,
          height: 28,
          url: 'https://static.rustore.ru/rustore-strapi/6/Iko_VK_28_2368eb6a8b.svg',
        },
      },
      {
        id: 11,
        href: 'https://dzen.ru/rustore',
        isTargetBlank: true,
        logoHref: {
          id: 1534,
          name: 'Iko_dzen_28.svg',
          width: 28,
          height: 28,
          url: 'https://static.rustore.ru/rustore-strapi/6/Iko_dzen_28_9dacd5d21f.svg',
        },
      },
    ],
    devLandingSocialLinks: [
      {
        id: 14,
        href: 'https://vk.com/rustore_official',
        isTargetBlank: true,
        logoHref: {
          id: 1535,
          name: 'Iko_VK_28.svg',
          width: 28,
          height: 28,
          url: 'https://static.rustore.ru/rustore-strapi/6/Iko_VK_28_2368eb6a8b.svg',
        },
      },
      {
        id: 13,
        href: 'https://t.me/rustoredev',
        isTargetBlank: true,
        logoHref: {
          id: 2625,
          name: 'telegram.svg',
          width: 28,
          height: 28,
          url: 'https://static.rustore.ru/rustore-strapi/6/telegram_905e827f78.svg',
        },
      },
    ],
    webSocialLinks: [
      {
        id: 15,
        href: 'https://t.me/rustoredev',
        isTargetBlank: true,
        logoHref: {
          id: 2625,
          name: 'telegram.svg',
          width: 28,
          height: 28,
          url: 'https://static.rustore.ru/rustore-strapi/6/telegram_905e827f78.svg',
        },
      },
    ],
  },
};
